// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"62dada96","453":"461b9ad1"}[chunkId] + ".chunk.js";
};